import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endpoint: String, modalId: { type: String, default: "landingSignupModal" } };
  static targets = ["form", "errors", "submit", "submitLabel", "spinner"];

  open(event) {
    if (event) event.preventDefault();
    const Modal = window.bootstrap && window.bootstrap.Modal;
    const modalEl = document.getElementById(this.modalIdValue);
    if (!Modal || !modalEl) return;
    Modal.getOrCreateInstance(modalEl).show();
  }

  async submit(event) {
    event.preventDefault();
    this.clearErrors();
    this.setLoading(true);

    const formData = new FormData(this.formTarget);
    const phone = formData.get("signup[phone]");
    if (typeof phone === "string") {
      formData.set("signup[phone]", phone.replace(/\D/g, ""));
    }

    try {
      const response = await fetch(this.endpointValue, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok && data.redirect_url) {
        this.trackLead();
        window.location.href = data.redirect_url;
        return;
      }

      this.showErrors(data.errors || ["Não foi possível criar sua conta. Tente novamente."]);
    } catch (_err) {
      this.showErrors(["Erro de conexão. Verifique sua internet e tente novamente."]);
    } finally {
      this.setLoading(false);
    }
  }

  trackLead() {
    if (typeof window.fbq !== "function") return;
    window.fbq("track", "Lead", { content_name: "landing_veterinario_autonomo" });
  }

  clearErrors() {
    if (!this.hasErrorsTarget) return;
    this.errorsTarget.hidden = true;
    this.errorsTarget.replaceChildren();
  }

  showErrors(errors) {
    if (!this.hasErrorsTarget) return;
    const messages = Array.isArray(errors) ? errors : [errors];
    const nodes = messages.map((message) => {
      const line = document.createElement("div");
      line.textContent = String(message);
      return line;
    });
    this.errorsTarget.replaceChildren(...nodes);
    this.errorsTarget.hidden = false;
  }

  setLoading(loading) {
    if (this.hasSubmitTarget) this.submitTarget.disabled = loading;
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.toggle("d-none", !loading);
    if (this.hasSubmitLabelTarget) {
      this.submitLabelTarget.textContent = loading ? "Criando conta..." : "Criar minha conta";
    }
  }
}
